module.exports = ":host button[mat-raised-button] {\n  border-radius: 24px;\n  padding: 0 20px;\n  font-weight: 600;\n  letter-spacing: 0.3px; }\n"